export const themes = {
  default: {
    thInput: 'w-full',
  },
};
